import * as React from 'react';
import { Grid } from 'semantic-ui-react';
import { Card } from '../../Card';
import { CardList } from '../../Card/CardList';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { formatMessageHelper, FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import { useConsultantPerformance } from '../../../shared/api/apiHooks';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import { normalizeCapitalization } from '../../../shared/helpers';
import analytics from '../../../shared/services/analytics/analytics';

interface GeniusCardOwnProps {
  isCurrentUser: boolean;
}

const GeniusCardWithoutIntl = ({ isCurrentUser, intl }: GeniusCardOwnProps & InjectedIntlProps) => {
  const { data, isFetching, isIdle } = useConsultantPerformance();

  if (isIdle) {
    return null;
  }

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card title={formatMessageHelper(intl, 'geniusCard.title')} headerRightElem={isCurrentUser ? <RightElemLink /> : null}>
        <CardList>
          <CardList.Title as="h2">
            {formatMessageHelper(intl, 'geniusCard.level')}
            {normalizeCapitalization(data?.performance.currentLevel)}
          </CardList.Title>
          <CardList.Title>{formatMessageHelper(intl, 'geniusCard.stats')}</CardList.Title>
          <CardList.Row>
            <CardList.Cell>{formatMessageHelper(intl, 'consultant.leaderboard.signals')}</CardList.Cell>
            <CardList.Cell>{isFetching ? <Skeleton width={20} /> : data?.performance.current.alphaCount}</CardList.Cell>
          </CardList.Row>
          <CardList.Row>
            <CardList.Cell modifiers={['cap']}>{formatMessageHelper(intl, 'consultant.leaderboard.pyramids')}</CardList.Cell>
            <CardList.Cell>{isFetching ? <Skeleton width={20} /> : data?.performance.current.pyramidCount}</CardList.Cell>
          </CardList.Row>
          <CardList.Row>
            <CardList.Cell>{formatMessageHelper(intl, 'consultant.leaderboard.combinedAlphaPerformance')}</CardList.Cell>
            <CardList.Cell>
              {isFetching ? (
                <Skeleton width={20} />
              ) : (
                data?.performance.current.combinedAlphaPerformance || formatMessageHelper(intl, 'genius.data.notAvailable')
              )}
            </CardList.Cell>
          </CardList.Row>
          <CardList.Row>
            <CardList.Cell>{formatMessageHelper(intl, 'consultant.leaderboard.combinedSelectedAlphaPerformance')}</CardList.Cell>
            <CardList.Cell>
              {isFetching ? (
                <Skeleton width={20} />
              ) : (
                data?.performance.current.combinedSelectedAlphaPerformance || formatMessageHelper(intl, 'genius.data.notAvailable')
              )}
            </CardList.Cell>
          </CardList.Row>
        </CardList>
      </Card>
    </Grid.Column>
  );
};

function RightElemLink() {
  const handleClick = React.useCallback(() => {
    analytics.trackCustomEvent('dashboard_click_genius_detail');
  }, []);

  return (
    <Link to="/genius/status" className="card__header-link" onClick={handleClick}>
      <FormattedMessageHelper id="geniusCard.all" />
    </Link>
  );
}

export default injectIntl(GeniusCardWithoutIntl);
